import { Capacitor } from '@capacitor/core';

/**
 * Robustly resolves the application's base public URL.
 * It strictly prevents 'capacitor://localhost' from leaking into shareable links.
 * 
 * Priority:
 * 1. Environment Variable (VITE_PUBLIC_APP_URL)
 * 2. Native Fallback (https://shuvo.pro)
 * 3. Web Fallback (window.location.origin)
 */
export function getAppUrl(): string {
    // 1. If running natively (iOS/Android), NEVER use window.location.origin
    // because it resolves to capacitor://localhost or http://localhost.
    // Instead, rely on the environment variable, or fallback to production URL.
    if (Capacitor.isNativePlatform()) {
        return import.meta.env.VITE_PUBLIC_APP_URL || 'https://shuvo.pro';
    }

    // 2. We are running on the Web.
    // In local development, we want to use localhost (e.g. http://localhost:5173) 
    // so authentication redirects back to the local dev server, not production.
    if (import.meta.env.DEV) {
        return window.location.origin;
    }

    // 3. Web Production fallback
    return import.meta.env.VITE_PUBLIC_APP_URL || window.location.origin;
}
